// extracted by mini-css-extract-plugin
export default {"wrapper":"product-list-wrapper_wrapper__xJi5u","container":"product-list-wrapper_container__PLWzo"};